import { Box, Fab, FormControlLabel, makeStyles, TextField } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import NumberInputField from '../ui/NumberInputField';
import { PocketSpringZoneModel } from '../../api/OrderSpringApi';
import { SpringMaterialCustomerPrice } from '../../api/SpringMaterialCustomerPriceApi';

type Properties = {
  readonly zone: PocketSpringZoneModel;
  readonly materialPrices: SpringMaterialCustomerPrice[];
  readonly setLength: (length: number) => void;
  readonly deleteZone: () => void;
};

const useStyles = makeStyles(theme => ({
  inputField: {
    width: 130
  },
  zoneActionButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));

const useZoneStyles = makeStyles(theme => ({
  root: {
    marginRight: 0
  },
  label: {
    width: 320
  },
}));

const PocketSpringZoneDefinition = (properties: Properties) => {
  const classes = useStyles();
  const zoneClasses = useZoneStyles();
  const materialPrices = properties.materialPrices;
  const zone = properties.zone;
  const zoneMaterialPrice = materialPrices[zone.material.id];

  return <Box display='flex' flexDirection='row'>
    <FormControlLabel
      classes={ zoneClasses }
      label={ `${zone.material.name} (${zone.material.thickness} mm) : ${zoneMaterialPrice === undefined ? '?' : zoneMaterialPrice.unitPrice} zł` }
      control={
        <NumberInputField
          classes={ classes }
          label='Długość'
          initialValue={ zone.length }
          onValueChange={ properties.setLength }
        />
      }
      labelPlacement='start'
    />
    <Fab
      className={ classes.zoneActionButton }
      aria-label='delete'
      color='secondary'
      onClick={ properties.deleteZone }
      size='small'
    >
      <DeleteIcon />
    </Fab>
  </Box>
};
export default PocketSpringZoneDefinition;